import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import axios from 'axios';
import { HeaderNav } from '../components/HeaderNav';
import { Footer } from '../components/Footer';
import { ShortPill } from '../components/ShortPill';
import { Badge } from '../components/ui/badge';
import { Skeleton } from '../components/ui/skeleton';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

export default function ShortsPage() {
  const [shorts, setShorts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    const fetchShorts = async () => {
      try {
        setLoading(true);
        const params = new URLSearchParams({ pageSize: '20' });
        if (filter !== 'all') {
          params.append('parentType', filter);
        }
        const response = await axios.get(`${API_URL}/api/shorts?${params.toString()}`);
        setShorts(response.data);
      } catch (error) {
        console.error('Error fetching shorts:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchShorts();
  }, [filter]);

  return (
    <>
      <Helmet>
        <title>Shorts - Quick Takes · B&B Magazine</title>
        <meta name="description" content="Quick summaries and highlights from B&B Magazine's articles and videos." />
        <link rel="canonical" href="https://cms-production-test.preview.emergentagent.com/shorts" />
      </Helmet>

      <HeaderNav />

      <main>
        <section className="w-full py-12 md:py-16">
          <div className="container max-w-[1000px] mx-auto px-4 sm:px-6 lg:px-8">
            <div className="mb-8">
              <span className="uppercase tracking-[0.18em] text-xs text-muted-foreground font-ui">
                Quick Takes
              </span>
              <h1 className="mt-2 font-display text-4xl md:text-5xl font-bold mb-4">
                Shorts
              </h1>
              <p className="text-muted-foreground text-lg max-w-[65ch]">
                Bite-sized summaries and key highlights from our articles and videos.
              </p>
            </div>

            {/* Filter Badges */}
            <div className="flex flex-wrap gap-2 mb-8">
              <Badge
                onClick={() => setFilter('all')}
                className={`cursor-pointer px-4 py-2 ${
                  filter === 'all'
                    ? 'bg-primary text-primary-foreground'
                    : 'bg-[hsl(var(--surface-2))] text-foreground hover:bg-[hsl(var(--surface-3))]'
                }`}
              >
                All
              </Badge>
              <Badge
                onClick={() => setFilter('article')}
                className={`cursor-pointer px-4 py-2 ${
                  filter === 'article'
                    ? 'bg-primary text-primary-foreground'
                    : 'bg-[hsl(var(--surface-2))] text-foreground hover:bg-[hsl(var(--surface-3))]'
                }`}
              >
                Articles
              </Badge>
              <Badge
                onClick={() => setFilter('video')}
                className={`cursor-pointer px-4 py-2 ${
                  filter === 'video'
                    ? 'bg-primary text-primary-foreground'
                    : 'bg-[hsl(var(--surface-2))] text-foreground hover:bg-[hsl(var(--surface-3))]'
                }`}
              >
                Videos
              </Badge>
            </div>

            {/* Shorts Grid */}
            {loading ? (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {Array.from({ length: 8 }).map((_, i) => (
                  <Skeleton key={i} className="h-28 w-full rounded-lg" />
                ))}
              </div>
            ) : shorts.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {shorts.map((short) => (
                  <ShortPill key={short.id} short={short} />
                ))}
              </div>
            ) : (
              <div className="text-center py-12">
                <p className="text-muted-foreground">No shorts found.</p>
              </div>
            )}
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}